export default [
	{
		type: "special",
		id: 1,
		items: [
			{
				id: 1,
				text: "Course of studies",
				label: [
					{
						id: 1,
						text: "Mechatronics",
					},
					{
						id: 2,
						text: "Systems Engineering",
					},
					{
						id: 3,
						text: "Quantum Engineering",
					},
					{
						id: 4,
						text: "MWWT",
					},
					{
						id: 5,
						text: "MuN",
					},
					{
						id: 6,
						text: "CuK/Embedded Systems",
					},
					{
						id: 7,
						text: "LA Technik",
					},
					{
						id: 8,
						text: "Computer Science",
					},
					{
						id: 9,
						text: "Other",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 2,
				type: "medium",
				text: "There was a scheduling collision with:",
			},
			{
				id: 3,
				text: "Was there any prior knowledge required that you lacked? If yes, which?",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		title: "Evaluation of the lecture",
		items: [
			{
				id: 4,
				text: "The lecture is structured well",
			},
			{
				id: 5,
				text: "The lecture notes are helpful.",
			},
			{
				id: 6,
				text: "The content is illustrative (examples).",
			},
			{
				id: 7,
				text: "The lecturer is able to convey the learning content in an understandable way.",
			},
			{
				id: 8,
				text: "The lecturer is always well prepared.",
			},
			{
				id: 9,
				text: "The lecturer inspires me for the subject.",
			},
		],
	},
	{
		type: "uni",
		id: 4,
		title: "Evaluation of the exercise",
		items: [
			{
				id: 10,
				text: "The exercise tasks are clearly understandable.",
			},
			{
				id: 11,
				text: "The requirements in the exercise are appropriate.",
			},
			{
				id: 12,
				text: "Exercise and lecture are well coordinated.",
			},
			{
				id: 13,
				text: "Questions are answered without any problems.",
			},
			{
				id: 14,
				text: "The exercise group leader is able to convey the content well.",
			},
			{
				id: 15,
				text: "The exercise group leader is well prepared for each exercise.",
			},
			{
				id: 16,
				text: "The exercise group leader is responsive enough to questions.",
			},
		],
	},
	{
		type: "uni",
		id: 5,
		title: "General Evaluation",
		items: [
			{
				id: 17,
				text: "The course follows a clear central theme (golden thread).",
			},
			{
				id: 18,
				text: "The rooms are adequate.",
			},
			{
				id: 19,
				text: "Information on the course is available online.",
			},
			{
				id: 20,
				text: "The organization of lecture and tutorials is good.",
			},
			{
				id: 21,
				text: "The criteria for obtaining the course credit were well defined from the outset.",
			},
			{
				id: 22,
				text: "The criteria for obtaining the course credit are transparent.",
			},
			{
				id: 23,
				text: "The criteria for obtaining the course credit are appropriate.",
			},
			{
				id: 24,
				text: "There was ample opportunity for interaction with the lecturer through the online tools.",
			},
			{
				id: 25,
				text: "There was ample opportunity for interaction with the other students through the online tools.",
			},
			{
				id: 26,
				text: "The online appointments were well organized.",
			},
			{
				id: 27,
				text: "The online materials (e.g. texts, quizzes, videos, etc.) contributed significantly to the understanding of the learning content.",
			},
			{
				id: 28,
				text: "The possibilities of digital teaching beyond traditional teaching (discussion forums, interactive assignments, etc.) were well used.",
			},
			{
				id: 29,
				text: "Overall, the digital elements of the event were good.",
			},
			{
				id: 30,
				text: "The course is an example of good digital education.",
			},
		],
	},
	{
		type: "bi",
		id: 5,
		items: [
			{
				id: 31,
				text: "The amount of the content was...",
			},
			{
				id: 32,
				text: "The pace of the course was...",
			},
			{
				id: 33,
				text: "The requirements of the course were...",
			},
		],
	},
	{
		type: "text",
		id: 6,
		items: [{ id: 34, type: "small", text: "Average time spent on the course (lecture, tutorial, preparation and follow-up, and bonus points) in hours per week:" }],
	},
	{
		type: "special",
		id: 7,
		items: [
			{
				id: 35,
				text: "Are the bonus points valid until the start of the course in the next rotation?",
				label: [
					{
						id: 1,
						text: "Yes",
					},
					{
						id: 2,
						text: "No",
					},
				],
			},
			{
				id: 36,
				text: "Is it possible to get the grade 'very good (1.0)' without bonus points?",
				label: [
					{
						id: 1,
						text: "Yes",
					},
					{
						id: 2,
						text: "No",
					},
				],
			},
			{
				id: 37,
				text: "Overall I evaluate the course with the grade",
				label: [
					{
						id: 1,
						text: "A",
					},
					{
						id: 2,
						text: "B",
					},
					{
						id: 3,
						text: "C",
					},
					{
						id: 4,
						text: "D",
					},
					{
						id: 5,
						text: "E",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 8,
		items: [
			{
				id: 38,
				text: "What was good about the course, or what should deﬁnitely stay?",
			},
			{
				id: 39,
				text: "What was bad about the course, or what should deﬁnitely be changed?",
			},
		],
	},
];
